import {LocalTime} from "./local-time.js";

function convertSecondsToDDHHMMSS(seconds: number): string {
    const days = Math.floor(seconds / (24 * 3600));
    const hours = Math.floor(seconds / 3600) % 24;
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = seconds % 60;

    const formattedHours = hours.toString().padStart(2, '0');
    const formattedMinutes = minutes.toString().padStart(2, '0');
    const formattedSeconds = remainingSeconds.toString().padStart(2, '0');
    let ans = '';
    if(days) ans += `${days}д&nbsp;`;
    if(hours) ans += `${formattedHours}ч&nbsp;`;
    ans += `${formattedMinutes}м&nbsp;${formattedSeconds}с`;
    return ans;
}
export class TimeCounter extends LocalTime{
    private interval!: any;
    connectedCallback() {
        super.connectedCallback();
        this.interval = setInterval(this.updateContent.bind(this), 1000)
    }
    get timeTitle(){
        const timeNow = Math.floor(+(new Date)/1000);
        const delta = this.utcTime - timeNow;
        if(delta < 0) return this.getAttribute('ended')! as string;
        return this.getAttribute('start') + convertSecondsToDDHHMMSS(delta);
    }
    disconnectedCallback(){
        clearTimeout(this.interval);
    }

}


if(customElements.get('time-counter')) console.warn("Element time-counter already exists... This shouldn't happen");
else customElements.define('time-counter', TimeCounter)
